var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-2d",staticStyle:{"position":"relative"}},[_c(_vm.currenIndex,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }